/*                                                      */
/*                                   */
import { subscribe_to_store } from '../../../store/utils.js';
import { get as get_store } from '../../../store/shared/index.js';
import { define_property, noop } from '../../shared/utils.js';
import { get } from '../runtime.js';
import { teardown } from './effects.js';
import { mutable_source, set } from './sources.js';
import { DEV } from 'esm-env';

/**
 *
 *
 *
 */
let is_store_binding = false;

let IS_UNMOUNTED = Symbol();

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function store_get(store, store_name, stores) {
	const entry = (stores[store_name] ??= {
		store: null,
		source: mutable_source(undefined),
		unsubscribe: noop
	});

	if (DEV) {
		entry.source.label = store_name;
	}

	/*                                                                                             */
	if (entry.store !== store && !(IS_UNMOUNTED in stores)) {
		entry.unsubscribe();
		entry.store = store ?? null;

		if (store == null) {
			entry.source.v = undefined; /*                                     */
			entry.unsubscribe = noop;
		} else {
			var is_synchronous_callback = true;

			entry.unsubscribe = subscribe_to_store(store, (v) => {
				if (is_synchronous_callback) {
					/*                                                                                    */
					/*                                                                                    */
					entry.source.v = v;
				} else {
					set(entry.source, v);
				}
			});

			is_synchronous_callback = false;
		}
	}

	/*                                                                                          */
	/*                                                                                             */
	/*                                    */
	if (store && IS_UNMOUNTED in stores) {
		return get_store(store);
	}

	return get(entry.source);
}

/**
 *
 *
 *
 *
 *
 *
 */
export function store_unsub(store, store_name, stores) {
	/*                                                   */
	let entry = stores[store_name];

	if (entry && entry.store !== store) {
		/*                                                                                       */
		entry.unsubscribe();
		entry.unsubscribe = noop;
	}

	return store;
}

/**
 *
 *
 *
 *
 *
 */
export function store_set(store, value) {
	store.set(value);
	return value;
}

/**
 *
 *
 */
export function invalidate_store(stores, store_name) {
	var entry = stores[store_name];
	if (entry.store !== null) {
		store_set(entry.store, entry.source.v);
	}
}

/**
 *
 *
 */
export function setup_stores() {
	/*                                   */
	const stores = {};

	function cleanup() {
		teardown(() => {
			for (var store_name in stores) {
				const ref = stores[store_name];
				ref.unsubscribe();
			}
			define_property(stores, IS_UNMOUNTED, {
				enumerable: false,
				value: true
			});
		});
	}

	return [stores, cleanup];
}

/**
 *
 *
 *
 *
 *
 */
export function store_mutate(store, expression, new_value) {
	store.set(new_value);
	return expression;
}

/**
 *
 *
 *
 *
 */
export function update_store(store, store_value, d = 1) {
	store.set(store_value + d);
	return store_value;
}

/**
 *
 *
 *
 *
 */
export function update_pre_store(store, store_value, d = 1) {
	const value = store_value + d;
	store.set(value);
	return value;
}

/**
 *
 */
export function mark_store_binding() {
	is_store_binding = true;
}

/**
 *
 *
 *
 *
 *
 *
 */
export function capture_store_binding(fn) {
	var previous_is_store_binding = is_store_binding;

	try {
		is_store_binding = false;
		return [fn(), is_store_binding];
	} finally {
		is_store_binding = previous_is_store_binding;
	}
}
